exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dealer-logo__label[data-v-1ab57b89] {\n  display: block;\n  font-size: 16px;\n  text-transform: uppercase;\n  -webkit-transform: scale(0.75);\n          transform: scale(0.75);\n  -webkit-transform-origin: left;\n          transform-origin: left;\n}\n.dealer-logo__label.tertiary--text[data-v-1ab57b89] {\n  font-weight: 700;\n}\n.dealer-logo__img[data-v-1ab57b89] {\n  max-width: 100%;\n  height: auto;\n}", ""]);

// exports
